import { useEventCallback, useUpdateEffect } from '@cian/react-utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { selectPeriod, selectRoomsCount } from 'shared/selectors/marketTrends';
import { setRoomsCount, setPeriod } from 'shared/slices/marketTrends';
import { getMarketTrendsData } from 'shared/thunks/marketTrends';
import { EPeriod } from 'shared/types/marketTrends';
import { trackPeriodFilterChange, trackRoomsCountFilterChange } from '../tracking';
import { EQueryParameters_1 as ERoomsCount } from 'shared/repositories/valuation-offer-history/v1/get-market-trand';

export const useFilters = () => {
  const dispatch = useAppDispatch();

  const roomsCount = useSelector(selectRoomsCount);

  const period = useSelector(selectPeriod);

  const onRoomsCountChange = useEventCallback((value: ERoomsCount) => {
    dispatch(setRoomsCount(value));
    trackRoomsCountFilterChange(value);
  });

  const onPeriodChange = useEventCallback((value: EPeriod) => {
    dispatch(setPeriod(value));
    trackPeriodFilterChange(value);
  });

  useUpdateEffect(() => {
    dispatch(getMarketTrendsData());
  }, [roomsCount, period]);

  return useMemo(
    () => ({
      roomsCount,
      period,
      onRoomsCountChange,
      onPeriodChange,
    }),
    [onPeriodChange, onRoomsCountChange, period, roomsCount],
  );
};
